module.exports = __webpack_public_path__ + "static/img/infectious-disease_icon-03.774360d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vaccinetest/infectious-disease_icon-03.png
// module id = Cp3S
// module chunks = 0